// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3drNa","col":"styles_col__2y7S6"};